import { DashboardCellRendererFrame, NoValuePlaceholder, SettingsInstanceIcon } from '@aleph/shared-components';
import classNames from 'classnames';
import { FC } from 'react';
import { noop } from 'lodash';
import useSpotifyClientMutator from 'wb-spotify/app/routes/superGrid/mutator/adAccount/hooks/useSpotifyAdClientMutator';
import { ICellRendererParams } from 'ag-grid-community';
import { SpotifyLevel } from 'wb-spotify/app/routes/superGrid/utils';
import SettingsBreakdownSelector from 'wb-spotify/app/routes/superGrid/cellRenderers/tool/settingsBreakdownSelector';
import useSpotifyRolePermissions from 'wb-spotify/app/common/hooks/useSpotifyPermissions';

const AdAccountSettingsCellRenderer: FC<ICellRendererParams> = (params) => {
	const { setMutatingClient } = useSpotifyClientMutator();
	const { canEditAdAccount } = useSpotifyRolePermissions();

	const areSettingsAccessible = canEditAdAccount && params?.data?.level === SpotifyLevel.AD_ACCOUNT;

	return (
		<DashboardCellRendererFrame>
			<div
				className={
					classNames(
						'w-full flex justify-center h-[64px] max-h-full items-center',
						!params?.data?.isCreate && 'cursor-pointer',
					)
				}
				onClick={
					areSettingsAccessible
						? () => setMutatingClient({
							...params.data,
							node: params.node,
							api:  params.api,
						})
						: noop
				}
			>
				{
					areSettingsAccessible
						? (
							<div className="flex w-[16px] justify-center items-center"
								data-testid="accountSettings"
							>
								<SettingsInstanceIcon />
							</div>
						)
						: <NoValuePlaceholder />
				}
			</div>
			<div className='flex flex-1 h-full w-full items-center justify-center'>
				<SettingsBreakdownSelector
					{...params}
				/>
			</div>
		</DashboardCellRendererFrame>
	);
};

export default AdAccountSettingsCellRenderer;
